import MomentUtils from '@date-io/moment';
import {
  Button,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  Checkbox,
} from '@material-ui/core';
import Tooltip from '@mui/material/Tooltip';
import CancelIcon from '@material-ui/icons/Cancel';
import {
  KeyboardDatePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import MuiPhoneNumber from 'material-ui-phone-number';
import React, { useEffect, useReducer, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomMultiSelect from '../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import KeyValuePairList from '../../../../shared/key-value-pair-list/KeyValuePairList';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import { formDataValidate, handleValidation } from '../../../../utils/formUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import {
  allHotelsSelector,
  allRestaurantSelector,
  allUIBuilderPagesSelector,
  allSpaInfoSelector,
  allUIBuilderFlowsSelector,
  allCategoriesSelector,
  allAmenityCategoriesSelector,
  allAmenitiesSelector,
  fetchAllRestaurant,
  fetchAllSpa,
  fetchAllAccommodations,
  fetchAllAmenities,
} from '../../../property/propertySlice';
import {
  allHouseKeeping,
  fetchAllInRoomDiningMenu,
  fetchAllServiceReqeust,
  inRoomDiningMenuSelector,
} from '../../../services/servicesSlice';
import {
  CTA_TYPES,
  OFFER_REDIRECT_OPTIONS,
  OFFER_CARD_MODULES,
  OFFER_CARDS_DROPDOWN_TYPE,
  OFFER_RECIPIENT_DROPDOWN,
  OFFER_CARDS_DROPDOWN_RECURS,
  OFFER_VALID_DATE_ERROR_MESSAGE,
  DAYS,
  CTA_CARD_PLACEMENT_MODULE_LIST,
  modulesWithoutSubModule,
} from '../../../../constants/OfferConst';
import { createNewOfferCard, updateOfferCards } from '../../../../utils/ServicesAPIUtils';
import {
  fetchAllOfferCards,
  fetchAllOffers,
  offerSelector,
  allCityGuideCategoriesSelector,
  feedbackSelector,
  fetchAllFeedback,
} from '../../cmsSlice';
import moment from 'moment';
import InfoIcon from '@mui/icons-material/Info';
import { isEmpty } from 'lodash';
import ScratchImageUpload from '../../../../shared/image-upload/ScratchImageUpload';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';
import { capitalizeFirstLetter } from '../../../../utils/commonUtils';

const isScheduleStillInvalid = (formData) => {
  const scheduleFields = Object?.fromEntries(
    Object?.entries(formData)?.filter(([, f]) => f?.tab === 2),
  );
  const basicOK = formDataValidate(scheduleFields, false);
  const hasCustomErrors = Object?.values(scheduleFields)?.some((f) =>
    Object?.values(f?.errors || {})?.some(Boolean),
  );
  return !basicOK || hasCustomErrors;
};
const isCTAStillInvalid = (formData) => {
  if (formData?.ctaStatus?.value === 'Inactive') return false;
  const selectedModule = formData?.redirectModuleData?.value?.trim();
  if (selectedModule && modulesWithoutSubModule?.some((m) => m?.id === selectedModule)) {
    return false;
  }
  const ctaFields = Object?.fromEntries(Object?.entries(formData)?.filter(([, f]) => f?.tab === 1));
  const basicOK = formDataValidate(ctaFields, false);
  const hasCustomErrors = Object?.values(ctaFields)?.some((f) =>
    Object?.values(f?.errors || {})?.some(Boolean),
  );
  return !basicOK || hasCustomErrors;
};

const OfferCardsCreate = (props) => {
  const { toggleDrawer, hotelId, offerItem, offerLoader, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const cmsOffer = useSelector(offerSelector);
  const allOffersInfo = useSelector(offerSelector);
  const originalHotels = useSelector(allHotelsSelector);
  const allRestaurants = useSelector(allRestaurantSelector);
  const allUIBuilderPages = useSelector(allUIBuilderPagesSelector);
  const allSpaInfo = useSelector(allSpaInfoSelector);
  const allHotelCompendiumInfo = useSelector(allAmenitiesSelector);
  const allFeedbackInfo = useSelector(feedbackSelector);
  const allAccomodationCategories = useSelector(allCategoriesSelector);
  const allServiceRequestInfo = useSelector(allHouseKeeping);
  const originalCGCategories = useSelector(allCityGuideCategoriesSelector);
  const originalAccCategories = useSelector(allCategoriesSelector);
  const originalHCCategories = useSelector(allAmenityCategoriesSelector);
  const inRoomDiningMenu = useSelector(inRoomDiningMenuSelector);
  const allUIBuilderFlows = useSelector(allUIBuilderFlowsSelector);

  const [tabValue, setTabValue] = useState(0);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [moduleData, setModuleData] = useState([]);
  const [days, setDays] = useState();
  const [preImgURL, setPreImgURL] = useState('');
  const [postImgURL, setPostImgURL] = useState('');
  const [popupImgURL, setPopupImgURL] = useState('');
  const [cardPlacementModuleData, setCardPlacementModuleData] = useState(
    CTA_CARD_PLACEMENT_MODULE_LIST,
  );

  const OFFER_CARD = [
    { id: 1, name: 'In-Room Dining', selected: false },
    { id: 2, name: 'Spa', selected: false },
    { id: 3, name: 'Meeting', selected: false },
    { id: 4, name: 'Restaurant', selected: false },
    { id: 5, name: 'My Trips', selected: false },
    { id: 6, name: 'Service Request', selected: false },
  ];
  const [offerCardList, setOfferCardList] = useState(OFFER_CARD);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    offer: {
      value: '',
      fieldName: 'Select Offer',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    offerType: {
      value: '',
      fieldName: 'Select Offer Card Type',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    name: {
      value: '',
      fieldName: 'Offer Card Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    recipient: {
      value: '',
      fieldName: 'Select Offer Recipient',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    status: {
      value: true,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },

    CTA: {
      value: '',
      fieldName: 'CTA',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    ctaStatus: {
      value: 'Inactive',
      fieldName: 'ctaStatus',
      errors: {},
      validations: [],
      tab: 1,
    },
    cardPlacementType: {
      value: 'MODULE',
      fieldName: 'cardPlacementType',
      errors: {},
      validations: [],
      tab: 1,
    },
    cardPlacementModule: {
      value: '',
      fieldName: 'Select module(s)',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    cardPlacementUIBuilderPage: {
      value: '',
      fieldName: 'Select page(s)',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    ctaDisplayTitle: {
      value: '',
      fieldName: 'CTA Display Title',
      errors: {},
      validations: [],
      tab: 1,
    },
    redirectTo: {
      value: '',
      fieldName: 'Redirect Option',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    redirectInAppPageData: {
      value: '',
      fieldName: 'Select In-App Page',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    redirectFlowData: {
      value: '',
      fieldName: 'Select Flow',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    redirectModuleData: {
      value: '',
      fieldName: 'Select Module',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    moduleId: {
      value: '',
      fieldName: '',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    redirectURL: {
      value: '',
      fieldName: 'Paste the redirect URL here',
      placeholder: 'URL',
      errors: {},
      validations: ['required', 'validUrl', 'safeURL'],
      tab: 1,
    },
    contact: {
      value: '',
      fieldName: 'Contact',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    email: {
      value: '',
      fieldName: 'Email Id',
      errors: {},
      validations: ['required', 'validEmail'],
      tab: 1,
    },
    phoneNumber: {
      value: '',
      fieldName: 'Phone Number',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    offerCard: {
      value: [],
      fieldName: 'Offer Card Placement',
      errors: {},
      validations: [],
      tab: 1,
    },
    schedule: {
      value: 'always',
      fieldName: 'Schedule',
      errors: {},
      validations: [],
      tab: 2,
    },
    days: {
      value: [],
      fieldName: 'days',
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    scheduleTime: {
      value: moment().add(1, 'hour').format('HH:mm'),
      fieldName: 'Time',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 2,
    },
    oneTimeDate: {
      value: moment().format('DD-MM-YYYY'),
      fieldName: 'Date',
      errors: {},
      validations: ['required', 'validDate'],
      tab: 2,
    },
    startDate: {
      value: moment().format('DD-MM-YYYY'),
      fieldName: 'Start Date',
      errors: {},
      validations: ['required', 'validDate'],
      tab: 2,
    },
    endDate: {
      value: moment().format('DD-MM-YYYY'),
      fieldName: 'End Date',
      errors: {},
      validations: ['required', 'validDate'],
      tab: 2,
    },
    recurs: {
      value: '',
      fieldName: 'Recurs Every',
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    oneTime: {
      value: moment().add(1, 'hour').format('HH:mm'),
      fieldName: 'Time',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 2,
    },
    recursTime: {
      value: moment().add(1, 'hour').format('HH:mm'),
      fieldName: 'Recurs at (Time)',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 2,
    },
    impression: {
      value: '',
      fieldName: 'No of impressions per day',
      errors: {},
      validations: ['required', 'positiveOnly'],
      tab: 2,
    },
    recursMonth: {
      value: '',
      fieldName: 'Dates',
      placeholder: 'Dates of month in numerical (Separated by commas)',
      errors: {},
      validations: ['required', 'validCustomMonthDates'],
      tab: 2,
    },
    preImages: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 3,
    },
    postImages: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 3,
    },
    popupImages: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 3,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    let tempData = [...cardPlacementModuleData];

    if (isEmpty(allRestaurants)) {
      tempData = tempData.map((x) => {
        if (x.id === 'RESTAURANT') {
          return {
            ...x,
            status: false,
          };
        }
        return x;
      });
    }

    if (isEmpty(allSpaInfo)) {
      tempData = tempData.map((x) => {
        if (x.id === 'SPA') {
          return {
            ...x,
            status: false,
          };
        }
        return x;
      });
    }
    if (isEmpty(originalAccCategories)) {
      tempData = tempData.map((x) => {
        if (x.id === 'ACCOMMODATION') {
          return {
            ...x,
            status: false,
          };
        }
        return x;
      });
    }
    if (isEmpty(originalCGCategories)) {
      tempData = tempData.map((x) => {
        if (x.id === 'CITY_GUIDE') {
          return {
            ...x,
            status: false,
          };
        }
        return x;
      });
    }
    if (isEmpty(inRoomDiningMenu)) {
      tempData = tempData.map((x) => {
        if (x.id === 'MENU_CONFIGS') {
          return {
            ...x,
            status: false,
          };
        }
        return x;
      });
    }
    if (isEmpty(originalHCCategories)) {
      tempData = tempData.map((x) => {
        if (x.id === 'HOTEL_COMPENDIUM') {
          return {
            ...x,
            status: false,
          };
        }
        return x;
      });
    }

    setCardPlacementModuleData(tempData);
  }, [
    inRoomDiningMenu,
    originalHCCategories,
    originalAccCategories,
    originalCGCategories,
    allRestaurants,
    allSpaInfo,
  ]);
  const resetTimesToNow = () => {
    const now = moment()?.format('HH:mm');
    const updates = {};

    ['scheduleTime', 'oneTime', 'recursTime']?.forEach((key) => {
      if (formData?.[key]) {
        const next = {
          ...formData[key],
          value: now,
          errors: { ...(formData[key]?.errors || {}) },
        };
        if (next.errors) {
          delete next.errors.validTime;
          delete next.errors.required;
        }
        updates[key] = next;
      }
    });

    setFormData(updates);
  };
  const isScheduleTabInvalid = () => {
    if (isScheduleStillInvalid(formData)) return true;
    if (formData?.schedule?.value === 'oneTime') {
      return isValidTime('oneTime');
    }
    if (formData?.schedule?.value === 'recurring') {
      if (validateTillFromDate()) return true;
      if (isValidTime('recursTime')) return true;
      if (formData?.recurs?.value === 'WEEK' && isValidWeekSelected()) return true;
      if (formData?.recurs?.value === 'MONTH' && isValidMonthDates()) return true;
    }
    return false;
  };
  const isStrictDDMMYYYY = (s) =>
    /^\d{2}-\d{2}-\d{4}$/.test(String(s || '')) && moment(s, 'DD-MM-YYYY', true)?.isValid();

  const revalidateDateField = (fieldName, { setValidations } = {}) => {
    const curr = { ...formData[fieldName], errors: { ...(formData[fieldName]?.errors || {}) } };
    if (setValidations) curr.validations = setValidations;
    const raw = curr?.value;
    if (!raw) {
      setFormData({ [fieldName]: curr });
      return;
    }
    const parsed = moment(raw, 'DD-MM-YYYY', true);
    const isPast = parsed?.isValid() && parsed?.startOf('day')?.isBefore(moment()?.startOf('day'));
    if (!isStrictDDMMYYYY(raw) || !parsed?.isValid() || isPast) {
      curr.errors.validDate = 'Invalid date';
    } else {
      if (curr.errors?.validDate) delete curr.errors.validDate;
      curr.value = parsed?.format('DD-MM-YYYY');
    }
    setFormData({ [fieldName]: curr });
  };
  useEffect(() => {
    if (formData?.schedule?.value === 'oneTime') {
      revalidateDateField('oneTimeDate');
    } else if (formData?.schedule?.value === 'recurring') {
      revalidateDateField('startDate');
      revalidateDateField('endDate');
    }
  }, [formData?.schedule?.value]);

  useEffect(() => {
    if (formData?.CTA?.value !== 'REDEEM' || formData?.redirectTo?.value !== 'Module') return;
    const selected = formData?.redirectModuleData?.value;
    if (!selected) return;
    const selectedHotel = originalHotels?.find((h) => h.id === hotelId);
    const withIds = selectedHotel
      ? { hotelId: selectedHotel.id, groupId: selectedHotel.groupId }
      : { hotelId };

    switch (selected) {
      case 'RESTAURANT':
        dispatch(fetchAllRestaurant(hotelId));
        break;
      case 'SPA':
        dispatch(fetchAllSpa(hotelId));
        break;
      case 'ACCOMMODATION':
        dispatch(fetchAllAccommodations(hotelId));
        break;
      case 'IRD':
        dispatch(fetchAllInRoomDiningMenu(hotelId));
        break;
      case 'SERVICE_REQUEST':
        dispatch(fetchAllServiceReqeust(hotelId));
        break;
      case 'HOTEL_COMPENDIUM':
        dispatch(fetchAllAmenities(hotelId));
        break;
      case 'OFFERS':
        dispatch(fetchAllOffers(hotelId));
        break;
      case 'FEEDBACK':
        if (typeof fetchFeedbackList === 'function') {
          dispatch(fetchAllFeedback(hotelId));
        }
        break;
      default:
        break;
    }
  }, [
    dispatch,
    hotelId,
    originalHotels,
    formData?.CTA?.value,
    formData?.redirectTo?.value,
    formData?.redirectModuleData?.value,
  ]);

  useEffect(() => {
    resetDaysData();
    generatedDays(DAYS, formData.startDate.value, formData.endDate.value);
  }, []);
  useEffect(() => {
    let tempUrl = {
      fileName: '',
      index: 0,
      master: preImgURL,
      ratio1to1: preImgURL,
      ratio16to9: preImgURL,
      ratio21to9: preImgURL,
      ratio9to16: preImgURL,
      ratio9to21: preImgURL,
    };
    const currFields = { ...formData.preImages };
    currFields.value = [tempUrl];
    setFormData({ preImages: currFields });
  }, [preImgURL]);

  useEffect(() => {
    let tempUrl = {
      fileName: '',
      index: 0,
      master: postImgURL,
      ratio1to1: postImgURL,
      ratio16to9: postImgURL,
      ratio21to9: postImgURL,
      ratio9to16: postImgURL,
      ratio9to21: postImgURL,
    };
    const currFields = { ...formData.postImages };
    currFields.value = [tempUrl];
    setFormData({ postImages: currFields });
  }, [postImgURL]);

  useEffect(() => {
    let tempUrl = {
      fileName: '',
      index: 0,
      master: popupImgURL,
      ratio1to1: popupImgURL,
      ratio16to9: popupImgURL,
      ratio21to9: popupImgURL,
      ratio9to16: popupImgURL,
      ratio9to21: popupImgURL,
    };
    const currFields = { ...formData.popupImgURL };
    currFields.value = [tempUrl];
    setFormData({ popupImages: currFields });
  }, [popupImgURL]);

  useEffect(() => {
    if (!isEmpty(offerItem)) {
      if (offerItem.offerCardType === 'SCRATCH_CARD' && !isEmpty(offerItem?.preScratchImages)) {
        setPreImgURL(offerItem?.preScratchImages[0]?.master);
      }
      if (offerItem.offerCardType === 'SCRATCH_CARD' && !isEmpty(offerItem?.postScratchImages)) {
        setPostImgURL(offerItem?.postScratchImages[0]?.master);
      }
      if (offerItem.offerCardType === 'POPUP_CARD' && !isEmpty(offerItem?.popUpImages)) {
        setPopupImgURL(offerItem?.popUpImages[0]?.master);
      }
      const currFields = { ...formData };

      currFields.offerType.value = offerItem.offerCardType;
      currFields.name.value = offerItem.offerCardName;
      currFields.offer.value = cmsOffer.find(
        (x) => x.status === 'Live' && x.id === offerItem.offerId,
      )
        ? offerItem.offerId
        : '';
      currFields.recipient.value = offerItem.offerRecipient;
      currFields.moduleId.value = offerItem?.CTA?.moduleId;
      currFields.CTA.value = offerItem.CTA.type;
      currFields.ctaStatus.value = !offerItem.CTA.status ? 'Inactive' : offerItem.CTA.status;

      currFields.cardPlacementType.value = offerItem.CTA?.cardPlacementType || 'MODULE';
      if (offerItem.CTA?.cardPlacementType === 'MODULE') {
        currFields.cardPlacementModule.value = offerItem.CTA?.cardPlacement;
      } else if (offerItem.CTA?.cardPlacementType === 'UI_BUILDER_PAGES') {
        const tempPages = allUIBuilderPages
          .filter(
            (item) =>
              item.status === 'Published' && offerItem.CTA?.cardPlacement?.includes(item?.id),
          )
          ?.map((item) => {
            return item?.id;
          });
        currFields.cardPlacementUIBuilderPage.value = tempPages || [];
      }
      if (offerItem.CTA.type === 'OK') {
        formData.ctaDisplayTitle.validations = [];
        formData.redirectTo.validations = [];
        formData.contact.validations = [];
        formData.email.validations = [];
        formData.phoneNumber.validations = [];
        formData.redirectInAppPageData.validations = [];
        formData.redirectFlowData.validations = [];
        formData.redirectModuleData.validations = [];
        formData.moduleId.validations = [];
      } else if (offerItem.CTA.type === 'REDEEM') {
        formData.redirectTo.validations = ['required'];
        if (offerItem.CTA.redirectTo == 'IN-APP PAGE') {
          formData.ctaDisplayTitle.validations = [];
          formData.redirectFlowData.validations = [];
          formData.redirectModuleData.validations = [];
          formData.redirectURL.validations = [];
          formData.contact.validations = [];
          formData.email.validations = [];
          formData.phoneNumber.validations = [];
          formData.moduleId.validations = [];
          formData.redirectInAppPageData.validations = ['required'];
          formData.redirectFlowData.value = '';
          formData.redirectModuleData.value = '';
          currFields.redirectInAppPageData.value = offerItem.CTA.redirectData;
          currFields.redirectTo.value = 'In-App Page';
        } else if (offerItem.CTA.redirectTo == 'EXTERNAL URL') {
          formData.redirectInAppPageData.validations = [];
          formData.redirectFlowData.validations = [];
          formData.redirectModuleData.validations = [];
          formData.contact.validations = [];
          formData.email.validations = [];
          formData.phoneNumber.validations = [];
          formData.moduleId.validations = [];
          formData.ctaDisplayTitle.validations = [];
          formData.redirectURL.validations = ['required', 'validUrl', 'safeURL'];
          currFields.redirectTo.value = 'External URL';
        } else if (offerItem.CTA.redirectTo == 'FLOW') {
          formData.redirectFlowData.validations = ['required'];
          formData.ctaDisplayTitle.validations = [];
          formData.redirectInAppPageData.validations = [];
          formData.redirectModuleData.validations = [];
          formData.redirectURL.validations = [];
          formData.contact.validations = [];
          formData.email.validations = [];
          formData.phoneNumber.validations = [];
          formData.moduleId.validations = [];
          formData.redirectInAppPageData.value = '';
          formData.redirectModuleData.value = '';
          currFields.redirectFlowData.value = offerItem.CTA.redirectData;
          currFields.redirectTo.value = 'Flow';
        } else if (offerItem.CTA.redirectTo == 'MODULE') {
          formData.ctaDisplayTitle.validations = [];
          formData.redirectModuleData.validations = ['required'];
          formData.redirectInAppPageData.validations = [];
          formData.redirectFlowData.validations = [];
          formData.redirectURL.validations = [];
          formData.contact.validations = [];
          formData.email.validations = [];
          formData.phoneNumber.validations = [];
          formData.redirectInAppPageData.value = '';
          formData.redirectFlowData.value = '';
          formData.moduleId.validations = ['required'];
          currFields.redirectModuleData.value =
            offerItem?.CTA?.redirectData || formData?.redirectModuleData?.value;
          currFields.redirectTo.value = 'Module';
        }
      } else if (offerItem.CTA.type === 'ENQUIRE') {
        formData.ctaDisplayTitle.validations = [];
        formData.redirectTo.validations = [];
        formData.redirectURL.validations = [];
        formData.contact.validations = ['required'];
      }
      currFields.ctaDisplayTitle.value = offerItem.CTA?.displayCTATitle;
      currFields.redirectURL.value = offerItem.CTA.URL;
      currFields.ctaDisplayTitle.value = offerItem.CTA.displayCTATitle;
      currFields.contact.value = offerItem.CTA.contact ? offerItem.CTA.contact.split(',') : [];
      currFields.phoneNumber.value = offerItem.CTA.phoneNumber;
      currFields.email.value = offerItem.CTA.emailId;
      currFields.offerCard.value = offerItem.CTA.cardPlacement;
      currFields.customAttributes.value = offerItem.customAttributes || [];
      const offerCardsFromEditOffer = offerCardList.map((card) => {
        return {
          ...card,
          selected: offerItem.CTA.cardPlacement.includes(card.name),
        };
      });
      setOfferCardList(offerCardsFromEditOffer);
      if (offerItem.schedule?.alwaysActive) {
        currFields.schedule.value = 'always';
      } else {
        if (offerItem.schedule?.scheduleType === 'ONE_TIME') {
          currFields.schedule.value = 'oneTime';
          currFields.oneTimeDate.value = offerItem.schedule?.oneTime?.date;
          currFields.oneTime.value = offerItem.schedule?.oneTime?.time;
        } else {
          currFields.schedule.value = 'recurring';
          currFields.startDate.value = offerItem.schedule?.recurring?.startDate;
          currFields.endDate.value = offerItem.schedule?.recurring?.endDate;
          currFields.impression.value = offerItem.schedule?.recurring?.impression;
          currFields.recursTime.value = offerItem.schedule?.recurring?.recursTime;
          currFields.recurs.value = offerItem.schedule?.recurring?.recurs || 'DAY';
          if (offerItem.schedule?.recurring?.recurs === 'MONTH') {
            currFields.recursMonth.value = offerItem.schedule?.recurring?.dates;
          } else if (offerItem.schedule?.recurring?.recurs === 'WEEK') {
            let generatedTimes = formatArrayForDisplay(offerItem?.schedule?.recurring?.recursWeek);
            generatedDays(
              generatedTimes,
              offerItem.schedule?.recurring?.startDate,
              offerItem.schedule?.recurring?.endDate,
            );
          }
        }
      }
      setFormData(currFields);
    }
  }, [offerItem]);

  const moduleDataMap = useMemo(
    () => ({
      RESTAURANT: allRestaurants,
      SPA: allSpaInfo,
      ACCOMMODATION: allAccomodationCategories,
      FEEDBACK: [],
      GRMS: [],
      LOYALTY: [],
      IRD: inRoomDiningMenu,
      SERVICE_REQUEST: allServiceRequestInfo,
      HOTEL_COMPENDIUM: allHotelCompendiumInfo,
      HOTEL_INFO: [],
      OFFERS: allOffersInfo,
      'CHECK IN': [],
      'DIGITAL KEY': [],
    }),
    [
      allRestaurants,
      allSpaInfo,
      allAccomodationCategories,
      inRoomDiningMenu,
      allServiceRequestInfo,
      allHotelCompendiumInfo,
      allOffersInfo,
    ],
  );

  useEffect(() => {
    setModuleData(moduleDataMap[formData?.redirectModuleData?.value] || []);

    if (formData?.CTA?.value === 'OK') {
      formData.CTA.errors = {};
      formData.redirectURL.validations = [];
      formData.redirectTo.validations = [];
      formData.contact.validations = [];
      formData.email.validations = [];
      formData.phoneNumber.validations = [];
      formData.redirectInAppPageData.validations = [];
      formData.redirectFlowData.validations = [];
      formData.redirectModuleData.validations = [];
      formData.moduleId.validations = [];
    } else if (formData?.CTA?.value === 'REDEEM') {
      formData.contact.validations = [];
      formData.redirectURL.validations = [];
      formData.ctaDisplayTitle.validations = [];
      formData.redirectFlowData.validations = [];
      formData.redirectModuleData.validations = [];
      formData.redirectURL.validations = [];
      formData.contact.validations = [];
      formData.email.validations = [];
      formData.phoneNumber.validations = [];
      formData.moduleId.validations = [];
      formData.redirectInAppPageData.validations = [];

      formData.redirectTo.validations = ['required'];
      if (formData.redirectTo.value == 'In-App Page') {
        setModuleData([]);
        formData.redirectInAppPageData.validations = ['required'];
      } else if (formData.redirectTo.value == 'External URL') {
        setModuleData([]);
        formData.redirectURL.validations = ['required', 'validUrl', 'safeURL'];
      } else if (formData.redirectTo.value == 'Flow') {
        setModuleData([]);
        formData.redirectFlowData.validations = ['required'];
      } else if (formData.redirectTo.value == 'Module') {
        formData.redirectModuleData.validations = ['required'];
        formData.moduleId.validations = ['required'];
      }
    } else if (formData?.CTA?.value === 'ENQUIRE') {
      formData.redirectURL.validations = [];
      formData.redirectTo.validations = [];
      formData.redirectInAppPageData.validations = [];
      formData.redirectFlowData.validations = [];
      formData.redirectModuleData.validations = [];
      formData.moduleId.validations = [];
      formData.contact.validations = ['required'];
      formData.email.validations = [];
      formData.phoneNumber.validations = [];
      if (formData.contact.value.includes('email')) {
        formData.email.validations = ['required', 'validEmailList'];
      }
      if (formData.contact.value.includes('phone')) {
        formData.phoneNumber.validations = ['required'];
      }
    }
    if (formData?.cardPlacementType?.value === 'MODULE') {
      formData.cardPlacementUIBuilderPage.validations = [];
      formData.cardPlacementModule.validations = ['required'];
    } else if (formData?.cardPlacementType?.value === 'UI_BUILDER_PAGES') {
      formData.cardPlacementModule.validations = [];
      formData.cardPlacementUIBuilderPage.validations = ['required'];
    }
  }, [formData, days, moduleDataMap]);

  useEffect(() => {
    const mode = formData?.schedule?.value;
    if (mode === 'oneTime') {
      revalidateDateField('oneTimeDate', { setValidations: ['required', 'validDate'] });
      setFormData({
        recurs: { ...formData.recurs, validations: [] },
        recursTime: { ...formData.recursTime, validations: [] },
        impression: { ...formData.impression, validations: [] },
        recursMonth: { ...formData.recursMonth, validations: [] },
        days: { ...formData.days, validations: [] },
        oneTime: { ...formData.oneTime, validations: ['required', 'validTime'] },
      });
      return;
    }
    if (mode === 'recurring') {
      revalidateDateField('startDate', { setValidations: ['required', 'validDate'] });
      revalidateDateField('endDate', { setValidations: ['required', 'validDate'] });
      setFormData({
        recurs: { ...formData.recurs, validations: ['required'] },
        recursTime: { ...formData.recursTime, validations: ['required', 'validTime'] },
        impression: { ...formData.impression, validations: ['required', 'positiveOnly'] },
        recursMonth: { ...formData.recursMonth, validations: [] },
        oneTimeDate: { ...formData.oneTimeDate, validations: [] },
        oneTime: { ...formData.oneTime, validations: [] },
      });
      return;
    }
    setFormData({
      recurs: { ...formData.recurs, validations: [] },
      recursTime: { ...formData.recursTime, validations: [] },
      impression: { ...formData.impression, validations: [] },
      recursMonth: { ...formData.recursMonth, validations: [] },
      days: { ...formData.days, validations: [] },
      oneTimeDate: { ...formData.oneTimeDate, validations: [] },
      oneTime: { ...formData.oneTime, validations: [] },
    });
  }, [formData?.schedule?.value]);

  useEffect(() => {
    const selectedDays = days?.filter((d) => d.ischecked === true);
    if (selectedDays) {
      const tempDays = { ...formData.days };
      tempDays.value = selectedDays;
      tempDays.validations = [];
      tempDays.errors = {};
      setFormData({ days: tempDays });
    }
  }, [days]);

  const toLabelCase = (str = '') =>
    str
      ?.toString()
      ?.toLowerCase()
      ?.replace(/_/g, ' ')
      ?.replace(/\b\w/g, (c) => c?.toUpperCase());
  const getModuleDisplayName = (id) => {
    return OFFER_CARD_MODULES?.find((m) => m?.id === id)?.name || toLabelCase(id || '');
  };

  useEffect(() => {
    const selId = formData?.redirectModuleData?.value;
    const next = { ...formData.moduleId };
    const pretty = getModuleDisplayName(selId);
    next.fieldName = selId ? `Select ${pretty}` : 'Select Sub Module';
    const parentChanged =
      (offerItem && offerItem?.CTA?.redirectData?.toLowerCase?.() !== selId?.toLowerCase?.()) ||
      !offerItem;
    if (parentChanged) next.value = '';
    setFormData({ moduleId: next });
  }, [formData?.redirectModuleData?.value, offerItem]);

  const generatedDays = (days, stDate, etDate) => {
    let allDays = getDaysOfWeekFromRange(stDate, etDate);
    const daysArray = days?.map((daysValue) => {
      return {
        ...daysValue,
        isDisable: allDays?.includes(daysValue.id) ? false : true,
        ischecked: !allDays?.includes(daysValue.id) ? false : daysValue?.ischecked,
      };
    });
    setDays(daysArray);
  };

  const isValidWeekSelected = () => {
    const tempStartDate = swapNumber(formData.startDate.value?.split('-')?.map(Number));
    const tempEndDate = swapNumber(formData.endDate.value?.split('-')?.map(Number));
    const stDate = moment(tempStartDate);
    const etDate = moment(tempEndDate);
    const diff = etDate.diff(stDate, 'days') + 1;
    const selectedDay = days?.filter((d) => d?.ischecked);
    if (formData.recurs.value === 'WEEK' && diff < selectedDay?.length) {
      return true;
    }
  };

  const swapNumber = (array) => {
    let arr1 = [...array];
    let temp = arr1[0];
    arr1[0] = arr1[arr1.length - 1];
    arr1[arr1.length - 1] = temp;
    return arr1;
  };

  const isAllNUmberValid = (num, min = 0) => {
    const tempDates = formData.recursMonth.value?.split(',')?.map(Number);
    return tempDates?.every((e) => {
      return e <= num && e > min;
    });
  };

  const isValidMonthDates = () => {
    const fromDate = moment(formData.startDate.value, 'DD-MM-YYYY');
    const toDate = moment(formData.endDate.value, 'DD-MM-YYYY');
    const monthData = [];
    let formDay = Number(fromDate.format('DD'));
    let toDay = Number(toDate.format('DD'));
    let isFloat = false;
    let formDataArray = formData.recursMonth.value.split(',');
    formDataArray.forEach((element) => {
      if (!Number.isInteger(Number(element))) {
        isFloat = true;
        return;
      }
    });
    if (isFloat) {
      return true;
    }
    while (toDate > fromDate || fromDate.format('M') === toDate.format('M')) {
      monthData.push(fromDate.format('MMMM'));
      fromDate.add(1, 'month');
    }

    if (!isEmpty(formData.recursMonth.value) && formDataArray.length) {
      if (monthData.length === 1 && !isAllNUmberValid(Number(toDay), Number(formDay - 1))) {
        return true;
      }
      if (monthData.length === 2) {
        let dataRange = [],
          isValidRang = false;
        for (let i = formDay; i <= moment(formData.startDate.value, 'YYYY-MM').daysInMonth(); i++) {
          dataRange.push(i);
        }
        for (let j = 1; j <= toDay; j++) {
          if (j == dataRange[0]) {
            break;
          }
          dataRange.push(j);
        }
        for (var checkDay = 0; checkDay < formDataArray.length; checkDay++) {
          let isDayValidRang = dataRange.find((item) => formDataArray[checkDay] == item);
          if (!isDayValidRang) {
            isValidRang = true;
            break;
          }
        }
        if (isValidRang) {
          return isValidRang;
        }
      }
      if (!isAllNUmberValid(31, 0)) {
        return true;
      }
    } else {
      return false;
    }
  };

  const isValidTime = (field) => {
    const now = moment();
    const selectedTime = moment(formData[field]?.value, 'HH:mm');

    if (field === 'recursTime' && formData?.schedule?.value === 'recurring') {
      const start = moment(formData?.startDate?.value, 'DD-MM-YYYY');
      const end = moment(formData?.endDate?.value, 'DD-MM-YYYY');
      const isSingleDayWindow = start.isSame(end, 'day');
      const isTodayWindow = start.isSame(now, 'day');
      const isInFuture = selectedTime.isSameOrAfter(now, 'minute');
      return isSingleDayWindow && isTodayWindow && !isInFuture;
    }

    if (field === 'oneTime' && formData?.schedule?.value === 'oneTime') {
      const selectedDateTime = moment(
        `${formData?.oneTimeDate?.value} ${formData?.oneTime?.value}`,
        'DD-MM-YYYY HH:mm',
      );
      return now.isAfter(selectedDateTime);
    }

    return false;
  };

  const formatArrayForDisplay = (selectedDay) => {
    return DAYS?.map(function (x) {
      let result = selectedDay?.find((e) => e?.toLowerCase() == x.name?.toLowerCase());
      if (result) {
        return { ...x, ischecked: true };
      } else {
        return { ...x };
      }
    });
  };

  const validateTillFromDate = () => {
    if (formData.schedule.value === 'recurring') {
      const startDate = moment(formData.startDate.value, 'DD-MM-YYYY');
      const endDate = moment(formData.endDate.value, 'DD-MM-YYYY');
      return !endDate.isSameOrAfter(startDate);
    }
    return;
  };

  const validate = (tabValue) => {
    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );

    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    const isModulesWithSubModules =
      tabValue === 1 &&
      modulesWithoutSubModule?.filter((module) =>
        module?.id?.includes(formData?.redirectModuleData?.value),
      );

    const isCtaInactive = tabValue === 1 && formData?.ctaStatus?.value === 'Inactive';

    if (tabValue === 2 && formData.schedule.value === 'always') {
      return true;
    }

    if (isCtaInactive || isModulesWithSubModules) {
      return true;
    }

    return isValid;
  };

  const resetDaysData = () => {
    const daysArray = DAYS.map((daysValue, ndx) => {
      return {
        id: ndx + 1,
        name: daysValue.name,
        ischecked: false,
        from: null,
        to: null,
      };
    });
    setDays(daysArray);
  };
  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
      return;
    }
    if (newValue > 1 && isCTAStillInvalid(formData)) {
      setTabValue(1);
      return;
    }
    if (newValue > 2 && isScheduleTabInvalid()) {
      setTabValue(2);
      return;
    }
    if (validate(tabValue) && !isTabInValid) {
      setTabValue(newValue);
    }
  };
  const onNextClick = () => {
    if (
      (tabValue !== 0 || validate(0)) &&
      (tabValue !== 1 || !isCTAStillInvalid(formData)) &&
      (tabValue !== 2 || !isScheduleTabInvalid())
    ) {
      setTabValue(tabValue + 1);
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };
  const isFeedbackRedirect = formData?.redirectModuleData?.value === 'FEEDBACK';

  const matchedFeedback = allFeedbackInfo.find((feed) => feed?.id === formData?.moduleId?.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate(0) && validate(1) && validate(2)) {
      setLoading(true);
      try {
        dispatch(stepUpLoaderCount());
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        let selectedDay;
        if (formData.schedule.value === 'recurring' && formData.recurs.value === 'WEEK') {
          selectedDay = days
            .filter((d) => d?.ischecked)
            .map((daysValue, ndx) => daysValue?.name?.toUpperCase());
        }
        const schedule =
          formData.schedule.value === 'always'
            ? {
                scheduleType: 'ALWAYS_ACTIVE',
                recurring: null,
                alwaysActive: true,
              }
            : formData.schedule.value === 'oneTime'
            ? {
                scheduleType: 'ONE_TIME',
                oneTime: {
                  date: formData.oneTimeDate.value,
                  time: formData.oneTime.value,
                },
                alwaysActive: false,
              }
            : {
                scheduleType: 'RECURRING',
                recurring: {
                  startDate: formData.startDate.value,
                  endDate: formData.endDate.value,
                  recurs: formData.recurs.value,
                  impression: formData.impression.value,
                  recursTime: formData.recursTime.value,
                  dates: formData.recurs.value === 'MONTH' ? formData.recursMonth?.value : '',
                  recursWeek: formData.recurs.value === 'WEEK' ? selectedDay : null,
                },
                alwaysActive: false,
              };
        let CTA = {};

        if (formData.ctaStatus.value === 'Active') {
          if (formData.CTA.value === 'ENQUIRE') {
            CTA = {
              type: formData.CTA.value,
              cardPlacement: formData.offerCard.value,
              contact: formData.contact.value.toString(),
              status: 'Active',
              displayCTATitle: formData.ctaDisplayTitle.value,
            };
            if (formData.contact.value.includes('email')) {
              CTA.emailId = formData.email.value;
            }
            if (formData.contact.value.includes('phone')) {
              CTA.phoneNumber = formData.phoneNumber.value;
            }
          } else if (formData.CTA.value === 'REDEEM') {
            if (formData.redirectTo.value === 'External URL') {
              CTA = {
                type: formData.CTA.value,
                redirectTo: 'EXTERNAL URL',
                URL: formData.redirectURL.value,
                displayCTATitle: formData.ctaDisplayTitle.value,
                status: 'Active',
              };
            } else if (formData.redirectTo.value === 'In-App Page') {
              CTA = {
                type: formData.CTA.value,
                redirectTo: 'IN-APP PAGE',
                redirectData: formData.redirectInAppPageData.value,
                displayCTATitle: formData.ctaDisplayTitle.value,
                status: 'Active',
              };
            } else if (formData.redirectTo.value === 'Flow') {
              CTA = {
                type: formData.CTA.value,
                redirectTo: 'FLOW',
                redirectData: formData.redirectFlowData.value,
                displayCTATitle: formData.ctaDisplayTitle.value,
                status: 'Active',
              };
            } else if (formData.redirectTo.value === 'Module') {
              CTA = {
                type: formData?.CTA?.value,
                redirectTo: 'MODULE',
                redirectData: formData?.redirectModuleData?.value,
                displayCTATitle: formData?.ctaDisplayTitle?.value,
                moduleId: isFeedbackRedirect ? matchedFeedback?.id : formData?.moduleId?.value,
                status: 'Active',
              };
            }
          } else {
            CTA = {
              type: formData.CTA.value,
              status: formData.ctaStatus.value,
              displayCTATitle: formData.ctaDisplayTitle.value,
            };
          }
          CTA.cardPlacementType = formData.cardPlacementType.value;
          CTA.cardPlacement =
            formData.cardPlacementType.value === 'MODULE'
              ? formData.cardPlacementModule.value
              : formData.cardPlacementUIBuilderPage.value;
        } else {
          CTA = {
            status: formData.ctaStatus.value,
            cardPlacement: [],
            cardPlacementType: '',
          };
        }
        const payload = {
          offerId: formData.offer.value,
          offerName: cmsOffer?.find((offer) => offer.id === formData.offer.value)?.name || '',
          offerCardName: formData.name.value,
          offerCardType: formData.offerType.value,
          offerRecipient: formData.recipient.value,
          customAttributes: formData.customAttributes.value,
          hotelId,
          preScratchImages:
            formData.offerType.value === 'SCRATCH_CARD' ? formData.preImages.value : [],
          postScratchImages:
            formData.offerType.value === 'SCRATCH_CARD' ? formData.postImages.value : [],
          popUpImages: formData.offerType.value === 'POPUP_CARD' ? formData.popupImages.value : [],
          schedule,
          CTA,
        };
        if (offerItem?.id) {
          payload.id = offerItem.id;
          await updateOfferCards(payload, language);
          notificationManager('success', 'Offer card updated successfully');
        } else {
          await createNewOfferCard(payload, language);
          notificationManager('success', 'Offer card created successfully');
        }
        dispatch(fetchAllOfferCards(hotelId));
        dispatch(fetchAllOffers(hotelId));
        setLoading(false);
        toggleDrawer('', false, '');
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          offerItem
            ? notificationManager('danger', 'Failed to update Offer')
            : notificationManager('danger', 'Failed to create Offer');
        }
        setLoading(false);
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      notificationManager('danger', 'Enter all required fields');
      if (!validate(2)) {
        setTabValue(2);
      }
      if (!validate(1)) {
        setTabValue(1);
      }
      if (!validate(0)) {
        setTabValue(0);
      }
    }
  };

  const handleRedirectToChange = (e) => {
    setFormData({
      redirectTo: e,
      redirectInAppPageData: { ...formData?.redirectInAppPageData, value: '' },
      redirectFlowData: { ...formData?.redirectFlowData, value: '' },
      redirectModuleData: { ...formData?.redirectModuleData, value: '' },
      moduleId: { ...formData?.moduleId, value: '' },
      redirectURL: { ...formData?.redirectURL, value: '' },
    });
    setModuleData([]);
  };
  const handleRedirectModuleDataChange = (e) => {
    setFormData({
      redirectModuleData: e,
      moduleId: { ...formData?.moduleId, value: '' },
    });
  };

  const handleCTAChange = (e) => {
    if (e.value === 'OK') {
      formData.redirectTo.validations = [];
      formData.redirectURL.validations = [];
      formData.contact.validations = [];
      formData.email.validations = [];
      formData.phoneNumber.validations = [];
    } else if (e.value === 'REDEEM') {
      formData.redirectTo.validations = ['required'];
      formData.redirectURL.validations = ['required', 'validUrl', 'safeURL'];
      formData.contact.validations = [];
      formData.email.validations = [];
      formData.phoneNumber.validations = [];
      if (formData?.redirectTo?.value === 'Module') {
        setFormData({
          redirectModuleData: { ...formData?.redirectModuleData, validations: ['required'] },
          moduleId: { ...formData?.moduleId, validations: ['required'] },
        });
      }
    } else if (e.value === 'ENQUIRE') {
      formData.redirectTo.validations = [];
      formData.redirectURL.validations = [];
      formData.contact.validations = ['required'];
    }
    setFormData({ CTA: e });
  };

  const handleChangeContactType = (e) => {
    formData.phoneNumber.validations = [];
    formData.email.validations = [];

    if (e.value.includes('email')) {
      formData.email.validations = ['required', 'validEmailList'];
    }

    if (e.value.includes('phone')) {
      formData.phoneNumber.validations = ['required'];
    }
    setFormData({ contact: e });
  };

  const handlePhoneNoChange = (phone, fieldName) => {
    const currField = { ...formData[fieldName] };
    currField.value = phone;
    handleValidation(currField);
    setFormData({ [fieldName]: currField });
  };

  const handleTimePickerChange = (date, value, type) => {
    const currTimeField = { ...formData[type] };
    currTimeField.value = value;
    handleValidation(currTimeField);
    setFormData({
      [type]: currTimeField,
    });
  };

  const handleDatePickerChange = (date, value, type) => {
    const curr = { ...formData[type], errors: { ...(formData[type]?.errors || {}) } };
    if (value == null || value === '') {
      curr.value = '';
      handleValidation(curr);
      setFormData({ [type]: curr });
      if (type === 'startDate' || type === 'endDate') {
        generatedDays(
          days,
          type === 'startDate' ? '' : formData.startDate.value,
          type === 'endDate' ? '' : formData.endDate.value,
        );
      }
      return;
    }
    if (typeof value === 'string') curr.value = value;
    if (date && moment(date)?.isValid()) curr.value = moment(date)?.format('DD-MM-YYYY');
    handleValidation(curr);
    const raw = curr.value;
    if (raw) {
      const parsed = moment(raw, 'DD-MM-YYYY', true);
      const isPast =
        parsed?.isValid() && parsed?.startOf('day')?.isBefore(moment()?.startOf('day'));

      if (!isStrictDDMMYYYY(raw) || !parsed?.isValid() || isPast) {
        curr.errors.validDate = 'Invalid date';
      } else {
        curr.value = parsed?.format('DD-MM-YYYY');
        if (curr?.errors?.validDate) delete curr?.errors?.validDate;
      }
    }
    setFormData({ [type]: curr });
    if (type === 'startDate' || type === 'endDate') {
      generatedDays(
        days,
        type === 'startDate' ? curr.value : formData?.startDate?.value,
        type === 'endDate' ? curr.value : formData?.endDate?.value,
      );
    }
  };

  const setErrorText = (type) => {
    if (formData[type].errors.required) return formData[type].errors.required;
    if (type === 'startDate' || type === 'endDate') {
      if (formData[type]?.errors?.validDate) return formData[type]?.errors?.validDate;
      if (type === 'endDate' && validateTillFromDate()) return OFFER_VALID_DATE_ERROR_MESSAGE;
    }
    if (type === 'oneTimeDate') {
      if (formData[type].errors.validDate) return formData[type].errors.validDate;
    } else {
      if (formData[type].errors.validTime) return formData[type].errors.validTime;
    }
    return null;
  };

  const getDaysOfWeekFromRange = (stDate, etDate) => {
    const startDate = moment(stDate, 'DD-MM-YYYY');
    const endDate = moment(etDate, 'DD-MM-YYYY');
    endDate.add(1, 'day');

    const daysOfWeek = [];

    let i = 0;

    while (i < 7 && startDate < endDate) {
      daysOfWeek.push(startDate.day());
      startDate.add(1, 'day');
      i++;
    }
    return daysOfWeek;
  };

  const onChangeCtaStatus = (e) => {
    formData.redirectTo.validations = [];
    formData.redirectURL.validations = [];
    formData.contact.validations = [];
    formData.email.validations = [];
    formData.phoneNumber.validations = [];
    formData.CTA.value = '';
    const ctaField = { ...formData.ctaStatus };
    const cta = { ...formData.CTA };
    cta.value = '';
    ctaField.value = e.target.value;
    setFormData({ ctaStatus: ctaField, CTA: cta });
  };

  const onChangeCardPlacementStatus = (e) => {
    const ctaField = { ...formData.cardPlacementType };
    ctaField.value = e.target.value;
    setFormData({ cardPlacementType: ctaField });
  };

  const onChangeScheduleStatus = (e) => {
    const next = e?.target?.value;
    const scheduleField = { ...formData.schedule, value: next };
    setFormData({ schedule: scheduleField });
    resetTimesToNow();
  };
  const revalidateOneTimeFields = () => {
    const nextDate = {
      ...formData.oneTimeDate,
      validations: ['required', 'validDate'],
      errors: { ...(formData.oneTimeDate?.errors || {}) },
    };
    const nextTime = {
      ...formData.oneTime,
      validations: ['required', 'validTime'],
      errors: { ...(formData.oneTime?.errors || {}) },
    };
    handleValidation(nextDate);
    handleValidation(nextTime);
    const raw = nextDate.value;
    if (raw) {
      const parsed = moment(raw, 'DD-MM-YYYY', true);
      const isPast =
        parsed?.isValid() && parsed?.startOf('day')?.isBefore(moment()?.startOf('day'));
      if (!isStrictDDMMYYYY(raw) || !parsed?.isValid() || isPast) {
        nextDate.errors = { ...(nextDate.errors || {}), validDate: 'Invalid date' };
      } else {
        nextDate.value = parsed?.format('DD-MM-YYYY');
        if (nextDate?.errors?.validDate) delete nextDate?.errors?.validDate;
      }
    }
    setFormData({ oneTimeDate: nextDate, oneTime: nextTime });
  };
  useEffect(() => {
    if (tabValue === 2 && isScheduleStillInvalid(formData)) {
      setIsTabInValid(true);
      return;
    }
    if (tabValue === 1 && formData?.ctaStatus?.value === 'Active') {
      if (!formData?.CTA?.value) {
        setIsTabInValid(true);
        return;
      }
      if (
        formData?.cardPlacementType?.value === 'MODULE' &&
        formData?.cardPlacementModule?.value?.length === 0
      ) {
        setIsTabInValid(true);
        return;
      }
      if (
        formData?.cardPlacementType?.value === 'UI_BUILDER_PAGES' &&
        formData?.cardPlacementUIBuilderPage?.value?.length === 0
      ) {
        setIsTabInValid(true);
        return;
      }
      if (formData?.CTA?.value === 'REDEEM') {
        if (!formData?.redirectTo?.value) {
          setIsTabInValid(true);
          return;
        }
        switch (formData?.redirectTo?.value) {
          case 'External URL':
            if (!formData?.redirectURL?.value) {
              setIsTabInValid(true);
              return;
            }
            break;
          case 'In-App Page':
            if (!formData?.redirectInAppPageData?.value) {
              setIsTabInValid(true);
              return;
            }
            break;
          case 'Flow':
            if (!formData?.redirectFlowData?.value) {
              setIsTabInValid(true);
              return;
            }
            break;
          case 'Module':
            if (!formData?.redirectModuleData?.value) {
              setIsTabInValid(true);
              return;
            }

            const requiredModules = [
              'RESTAURANT',
              'SPA',
              'ACCOMMODATION',
              'HOTEL_COMPENDIUM',
              'IRD',
              'SERVICE_REQUEST',
              'OFFERS',
            ];

            if (
              requiredModules?.includes(formData?.redirectModuleData?.value) &&
              !formData?.moduleId?.value
            ) {
              setIsTabInValid(true);
              return;
            }
            break;
        }
      }

      if (formData?.CTA?.value === 'ENQUIRE') {
        const contacts = formData?.contact?.value || [];
        if (contacts?.length === 0) {
          setIsTabInValid(true);
          return;
        }

        if (
          (contacts?.includes('email') && !formData?.email?.value?.trim()) ||
          formData?.email?.errors?.validEmailList ||
          formData?.email?.errors?.validEmail
        ) {
          setIsTabInValid(true);
          return;
        }
        if (contacts?.includes('phone')) {
          const digits = formData?.phoneNumber?.value || '';
          if (digits?.length < 12) {
            setIsTabInValid(true);
            return;
          }
        }
      }
    }
    const isAlwaysSchedule = tabValue === 2 && formData?.schedule?.value === 'always';
    const isModulesWithSubModules =
      tabValue === 1 &&
      modulesWithoutSubModule?.filter((module) =>
        module?.id?.includes(formData?.redirectModuleData?.value),
      );

    const isCtaInactive = tabValue === 1 && formData?.ctaStatus?.value === 'Inactive';

    if (isCtaInactive || isModulesWithSubModules || isAlwaysSchedule) {
      return setIsTabInValid(false);
    }

    if (tabValue === 2 && formData.schedule.value === 'recurring' && validateTillFromDate()) {
      return setIsTabInValid(true);
    }

    if (
      tabValue === 2 &&
      formData.schedule.value === 'recurring' &&
      formData.recurs.value === 'WEEK' &&
      isValidWeekSelected()
    ) {
      return setIsTabInValid(true);
    }
    if (
      tabValue === 2 &&
      formData.schedule.value === 'recurring' &&
      formData.recurs.value === 'MONTH' &&
      isValidMonthDates()
    ) {
      return setIsTabInValid(true);
    }

    if (tabValue === 2 && formData.schedule.value === 'recurring' && isValidTime('recursTime')) {
      return setIsTabInValid(true);
    }

    if (tabValue === 2 && formData.schedule.value === 'oneTime' && isValidTime('oneTime')) {
      return setIsTabInValid(true);
    }
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
  }, [formData, tabValue]);

  const handleDaysChange = (e, dayndx) => {
    const currDays = [...days];
    currDays[dayndx].ischecked = e.target.checked;
    setDays(currDays);
  };

  const moduleRenderCustomDisplay = (selectedValue) => {
    const displayName = selectedValue.map((itemData) => {
      const item = CTA_CARD_PLACEMENT_MODULE_LIST.find((ild) => ild.id === itemData);
      return item?.name;
    });
    const formItem = { ...formData.cardPlacementModule };
    formItem.fieldName = `${selectedValue.length} selected`;
    return <span>{displayName.join(', ')}</span>;
  };

  const pagesRenderCustomDisplay = (selectedValue) => {
    const displayName = selectedValue
      .map((itemData) => {
        const item = allUIBuilderPages
          .filter((item) => item.status === 'Published')
          ?.find((ild) => ild.id === itemData);
        return item?.name;
      })
      .filter((item) => item);
    const formItem = { ...formData.cardPlacementUIBuilderPage };
    formItem.fieldName = `${selectedValue.length} selected`;
    return <span>{displayName.join(', ')}</span>;
  };

  return (
    <form onSubmit={handleSubmit} className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-5'>
            <span className='page-title'>
              {!isEmpty(offerItem) ? 'Edit Offer Card' : 'Create New Offer Card'}
            </span>
          </div>
          <div className='col-md-6'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='roomTypes-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='CTA' />
              <Tab label='Schedule' />
              <Tab label='Images' />
            </Tabs>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          {tabValue === 0 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <h5 className='tab-title'>Details</h5>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.offer}
                    handleInputChange={(e) => {
                      setFormData({ offer: e });
                    }}
                    labelField='name'
                    valueField='id'
                    options={cmsOffer.filter((x) => x.status === 'Live')}
                    hideNullOption={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.offerType}
                    handleInputChange={(e) => {
                      setFormData({ offerType: e });
                    }}
                    labelField='name'
                    valueField='id'
                    options={OFFER_CARDS_DROPDOWN_TYPE}
                    hideNullOption={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.name}
                    handleInputChange={(e) => {
                      setFormData({ name: e });
                    }}
                    maxLength={100}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.recipient}
                    handleInputChange={(e) => {
                      setFormData({ recipient: e });
                    }}
                    labelField='name'
                    valueField='id'
                    options={OFFER_RECIPIENT_DROPDOWN}
                    hideNullOption={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <KeyValuePairList
                    item={formData.customAttributes}
                    onListChange={(e) => {
                      setFormData({ customAttributes: e });
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          {tabValue === 1 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <h4 className='tab-title'>CTA</h4>
              <div className='custom-upload col-md-12'>
                <RadioGroup
                  row
                  aria-label={formData.ctaStatus.fieldName}
                  onChange={(e) => {
                    onChangeCtaStatus(e);
                  }}
                  value={formData.ctaStatus.value}
                  name={formData.ctaStatus.fieldName}
                  className='document-type mb-3'
                >
                  <FormControlLabel
                    value='Active'
                    control={<Radio color='primary' />}
                    label='Active'
                    className='me-5'
                  />
                  <FormControlLabel
                    value='Inactive'
                    control={<Radio color='primary' />}
                    label='Inactive'
                  />
                </RadioGroup>
              </div>
              {formData.ctaStatus.value === 'Active' && (
                <>
                  <div className='row'>
                    <div className='row'>
                      <div className='col-md-6 mb-3'>
                        <CustomSelect
                          item={formData.CTA}
                          handleInputChange={(e) => {
                            handleCTAChange(e);
                          }}
                          options={CTA_TYPES}
                          labelField='name'
                          valueField='id'
                          hideNullOption
                        />
                      </div>
                      <div className='col-md-6 mb-3'>
                        <CustomTextField
                          item={formData.ctaDisplayTitle}
                          handleInputChange={(e) => {
                            setFormData({ ctaDisplayTitle: e });
                          }}
                          maxLength={100}
                          endAdornment={true}
                          characterCount={true}
                        />
                      </div>
                    </div>
                    {formData.CTA.value === 'REDEEM' && (
                      <div className='row'>
                        <div className='col-md-6 mb-3'>
                          <CustomSelect
                            item={formData.redirectTo}
                            handleInputChange={handleRedirectToChange}
                            options={OFFER_REDIRECT_OPTIONS}
                            hideNullOption
                            multiline
                          />
                        </div>
                        {formData.redirectTo.value == 'In-App Page' && (
                          <div className='col-md-6 mb-3'>
                            <CustomSelect
                              item={formData.redirectInAppPageData}
                              handleInputChange={(e) => {
                                setFormData({ redirectInAppPageData: e });
                              }}
                              options={allUIBuilderPages.filter(
                                (item) => item.status === 'Published',
                              )}
                              hideNullOption
                              multiline={true}
                              labelField='name'
                              valueField='id'
                            />
                          </div>
                        )}
                        {formData.redirectTo.value == 'Flow' && (
                          <div className='col-md-6 mb-3'>
                            <CustomSelect
                              item={formData.redirectFlowData}
                              handleInputChange={(e) => {
                                setFormData({ redirectFlowData: e });
                              }}
                              options={allUIBuilderFlows}
                              hideNullOption
                              multiline={true}
                              labelField='label'
                              valueField='id'
                            />
                          </div>
                        )}
                        {formData.redirectTo.value == 'Module' && (
                          <div className='col-md-6 mb-3'>
                            <CustomSelect
                              item={formData.redirectModuleData}
                              handleInputChange={handleRedirectModuleDataChange}
                              labelField='name'
                              valueField='id'
                              options={OFFER_CARD_MODULES}
                              hideNullOption
                              isRequired
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {formData.CTA.value === 'ENQUIRE' && (
                      <div className='col-md-6 mb-3'>
                        <CustomMultiSelect
                          item={formData.contact}
                          labelField='name'
                          valueField='id'
                          options={[
                            { name: 'Email Id', id: 'email' },
                            { name: 'Phone Number', id: 'phone' },
                          ]}
                          hideNullOption={true}
                          handleInputChange={(e) => {
                            handleChangeContactType(e);
                          }}
                        />
                      </div>
                    )}
                  </div>
                  {formData.CTA.value === 'ENQUIRE' && (
                    <div>
                      {formData.contact.value.includes('email') && (
                        <div className='row'>
                          <div className='col-md-6'>
                            <CustomTextField
                              item={formData.email}
                              handleInputChange={(e) => {
                                setFormData({ email: e });
                              }}
                              maxLength={100000}
                              multiline={true}
                            />
                          </div>
                          <div className='col-md-6 d-flex align-items-center'>
                            <Tooltip
                              title='Add Multiple Email ids, separated by commas'
                              placement='right'
                            >
                              <InfoIcon
                                fontSize='small'
                                className='justify-content-start align-self-center mt-1'
                              />
                            </Tooltip>
                          </div>
                        </div>
                      )}

                      {formData.contact.value.includes('phone') && (
                        <div className='row mt-3'>
                          <div className='col-md-6'>
                            <MuiPhoneNumber
                              name='phone'
                              label='Phone Number'
                              data-cy='user-phone'
                              defaultCountry={'in'}
                              required={true}
                              disableAreaCodes
                              autoFormat={true}
                              countryCodeEditable={false}
                              value={formData.phoneNumber.value}
                              className='col-md-12'
                              onChange={(phone, country) =>
                                handlePhoneNoChange(phone, 'phoneNumber')
                              }
                              sx={{ '& svg': { height: '1.2rem' } }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {formData.CTA.value === 'REDEEM' &&
                    formData.redirectTo.value == 'External URL' && (
                      <div className='row'>
                        <div className='col-md-12'>
                          <CustomTextField
                            item={formData.redirectURL}
                            handleInputChange={(e) => {
                              setFormData({ redirectURL: e });
                            }}
                            maxLength={100000}
                          />
                        </div>
                      </div>
                    )}
                  {formData?.redirectModuleData?.value && moduleData?.length > 0 && (
                    <div className='row'>
                      <div className='col-md-6 mb-3'>
                        <CustomSelect
                          item={{
                            ...formData?.moduleId,
                            fieldName: `Select ${getModuleDisplayName(
                              formData?.redirectModuleData?.value,
                            )}`,
                          }}
                          handleInputChange={(e) => {
                            setFormData({ moduleId: e });
                          }}
                          options={moduleData}
                          hideNullOption
                          multiline={true}
                          labelField={isFeedbackRedirect ? 'pageTitle' : 'name'}
                          valueField='id'
                        />
                      </div>
                    </div>
                  )}
                  <div className='mt-4 d-flex row'>
                    <div className='mb-2'>
                      <div className='tab-title'>Offer Card Placement</div>
                      <div className='custom-upload col-md-12'>
                        <RadioGroup
                          row
                          aria-label={formData.cardPlacementType.fieldName}
                          onChange={(e) => {
                            onChangeCardPlacementStatus(e);
                          }}
                          value={formData.cardPlacementType.value}
                          name={formData.cardPlacementType.fieldName}
                          className='document-type mb-3'
                        >
                          <FormControlLabel
                            value='MODULE'
                            control={<Radio color='primary' />}
                            label='Module'
                            className='me-5'
                          />
                          <FormControlLabel
                            value='UI_BUILDER_PAGES'
                            control={<Radio color='primary' />}
                            label='UI Builder Pages'
                          />
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                  {formData.cardPlacementType.value === 'MODULE' && (
                    <div className='row'>
                      <div className='col-md-6 mb-1'>
                        <CustomMultiSelect
                          item={formData.cardPlacementModule}
                          options={cardPlacementModuleData}
                          hideNullOption={true}
                          valueField='id'
                          labelField='name'
                          handleInputChange={(e) => setFormData({ cardPlacementModule: e })}
                          isCustomDisplay={true}
                          renderCustomDisplay={moduleRenderCustomDisplay}
                        />
                      </div>
                    </div>
                  )}
                  {formData.cardPlacementType.value === 'UI_BUILDER_PAGES' && (
                    <div className='row'>
                      <div className='col-md-6 mb-1'>
                        <CustomMultiSelect
                          item={formData.cardPlacementUIBuilderPage}
                          options={allUIBuilderPages.filter((item) => item.status === 'Published')}
                          hideNullOption={true}
                          valueField='id'
                          labelField='name'
                          handleInputChange={(e) => setFormData({ cardPlacementUIBuilderPage: e })}
                          isCustomDisplay={true}
                          renderCustomDisplay={pagesRenderCustomDisplay}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
          {tabValue === 2 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <h4 className='tab-title'>Schedule</h4>
              <div className='custom-upload col-md-12'>
                <RadioGroup
                  row
                  aria-label={formData.schedule.fieldName}
                  onChange={(e) => {
                    onChangeScheduleStatus(e);
                  }}
                  value={formData.schedule.value}
                  name={formData.schedule.fieldName}
                  className='document-type mb-3'
                >
                  <FormControlLabel
                    value='always'
                    control={<Radio color='primary' />}
                    label='Always Active'
                    className='me-5'
                  />
                  <FormControlLabel
                    value='oneTime'
                    control={<Radio color='primary' />}
                    label='One-time'
                    className='me-5'
                  />
                  <FormControlLabel
                    value='recurring'
                    control={<Radio color='primary' />}
                    label='Recurring'
                  />
                </RadioGroup>
              </div>
              {formData.schedule.value === 'oneTime' && (
                <>
                  <div className='row'>
                    <div className='col-md-6 mb-2'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          minDate={new Date()}
                          variant='inline'
                          margin='normal'
                          id='oneTimeDate'
                          label='Date'
                          className='col-md-12 mb-2'
                          format='DD-MM-YYYY'
                          required={formData.oneTimeDate.validations.includes('required')}
                          inputValue={formData.oneTimeDate.value}
                          onChange={(date, value) =>
                            handleDatePickerChange(date, value, 'oneTimeDate')
                          }
                          error={
                            formData.oneTimeDate?.errors.required ||
                            formData.oneTimeDate?.errors.validDate
                              ? true
                              : false
                          }
                          helperText={setErrorText('oneTimeDate')}
                          disableMaskedInput
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                    <div className='col-md-6'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardTimePicker
                          variant='inline'
                          margin='normal'
                          id='oneTime'
                          label='Time'
                          className='col-md-12 mb-2'
                          ampm={false}
                          format='HH:mm'
                          required={formData.oneTime.validations.includes('required')}
                          inputValue={formData.oneTime.value}
                          onChange={(date, value) => handleTimePickerChange(date, value, 'oneTime')}
                          error={
                            formData.oneTime?.errors.required || formData.oneTime?.errors.validTime
                              ? true
                              : false
                          }
                          helperText={setErrorText('oneTime')}
                          keyboardIcon={<WatchLaterIcon />}
                        />
                      </MuiPickersUtilsProvider>
                      {isValidTime('oneTime') && (
                        <div className='input-error mt-2'>Please select valid time</div>
                      )}
                    </div>
                  </div>
                </>
              )}
              {formData.schedule.value === 'recurring' && (
                <>
                  <div className='row'>
                    <div className='col-md-6 mb-2'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          minDate={new Date()}
                          variant='inline'
                          margin='normal'
                          id='startDate'
                          label='Start Date'
                          className='col-md-12 mb-2'
                          format='DD-MM-YYYY'
                          required={formData.startDate.validations.includes('required')}
                          inputValue={formData.startDate.value}
                          onChange={(date, value) =>
                            handleDatePickerChange(date, value, 'startDate')
                          }
                          error={
                            formData.startDate?.errors.required ||
                            formData.startDate?.errors.validDate
                              ? true
                              : false
                          }
                          helperText={setErrorText('startDate')}
                          disableMaskedInput
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                    <div className='col-md-6'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          minDate={new Date()}
                          variant='inline'
                          margin='normal'
                          id='endDate'
                          label='End Date'
                          className='col-md-12 mb-2'
                          format='DD-MM-YYYY'
                          required={formData.endDate.validations.includes('required')}
                          inputValue={formData.endDate.value}
                          onChange={(date, value) => handleDatePickerChange(date, value, 'endDate')}
                          error={
                            formData.endDate?.errors.required ||
                            formData.endDate?.errors.validDate ||
                            validateTillFromDate()
                              ? true
                              : false
                          }
                          helperText={setErrorText('endDate')}
                          disableMaskedInput
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-6 mt-3'>
                      <CustomSelect
                        item={formData.recurs}
                        handleInputChange={(e) => {
                          generatedDays(DAYS, formData.startDate.value, formData.endDate.value);
                          setFormData({ recurs: e });
                        }}
                        labelField='name'
                        valueField='id'
                        options={OFFER_CARDS_DROPDOWN_RECURS}
                        hideNullOption={true}
                      />
                    </div>
                    <div className='col-md-6'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardTimePicker
                          variant='inline'
                          margin='normal'
                          id='recursTime'
                          label='Recurs at (Time)'
                          className='col-md-12 mb-2'
                          ampm={false}
                          format='HH:mm'
                          required={formData.recursTime.validations.includes('required')}
                          inputValue={formData.recursTime.value}
                          onChange={(date, value) =>
                            handleTimePickerChange(date, value, 'recursTime')
                          }
                          error={
                            formData.recursTime?.errors.required ||
                            formData.recursTime?.errors.validTime
                              ? true
                              : false
                          }
                          helperText={setErrorText('recursTime')}
                          keyboardIcon={<WatchLaterIcon />}
                        />
                      </MuiPickersUtilsProvider>
                      {isValidTime('recursTime') && (
                        <div className='input-error mt-2'>Please select valid time</div>
                      )}
                    </div>
                  </div>
                  <div className='row mt-4'>
                    {formData.recurs.value === 'WEEK' && (
                      <div className='custom-upload mb-2 col-md-12'>
                        {days &&
                          days.length > 0 &&
                          days.map((dayKey, dayNdx) => (
                            <FormControlLabel
                              className='document-type pe-3'
                              key={dayKey.id}
                              control={
                                <Checkbox
                                  color='primary'
                                  checked={dayKey.ischecked}
                                  onChange={(e) => handleDaysChange(e, dayNdx)}
                                  name='days'
                                  disabled={dayKey?.isDisable}
                                />
                              }
                              label={dayKey.name}
                            />
                          ))}
                        <div className='input-error mt-2'>
                          {isValidWeekSelected() && (
                            <div>Please choose days that are valid based on the range</div>
                          )}
                        </div>
                      </div>
                    )}
                    {formData.recurs.value === 'MONTH' && (
                      <>
                        <div className='col-md-6 mb-3'>
                          <CustomTextField
                            item={formData.recursMonth}
                            handleInputChange={(e) => {
                              setFormData({ recursMonth: e });
                            }}
                            label='Dates of month in numerical(Separated by commas)'
                          />
                          <div className='input-error mt-2'>
                            {isValidMonthDates() && (
                              <div>
                                <p>
                                  Invalid Selected Date <br />
                                  a. Dates can not contain special character. <br />
                                  b. Dates can not contain Decimal, Integer. <br />
                                  c. Dates can not contain empty values or '0'.
                                  <br />
                                  d. Dates can not contain invalid date.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className='info-icon col-md-3 d-flex align-items-center'>
                          <Tooltip
                            title='Add the Valid dates for the offers to be displayed'
                            placement='right-end'
                          >
                            <InfoIcon />
                          </Tooltip>
                        </div>
                      </>
                    )}
                  </div>
                  <div className='row mt-4'>
                    <div className='row'>
                      <div className='tab-title col-md-3'>Impressions</div>
                      <div className='info-icon col-md-3 d-flex align-items-center'>
                        <Tooltip
                          title='For multiple impressions, interval between cards is set to 8hrs by default'
                          placement='right-end'
                        >
                          <InfoIcon />
                        </Tooltip>
                      </div>
                    </div>

                    <div className='col-md-6 mb-3'>
                      <CustomTextField
                        item={formData?.impression}
                        handleInputChange={(e) => {
                          setFormData({ impression: e });
                        }}
                        max={10}
                        type={'number'}
                        disableDot
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
          {tabValue === 3 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <div className='col-md-12 mb-3'>
                <h4 className='tab-title '>Images</h4>
                <ScratchImageUpload
                  groupId={originalHotels.find((hotel) => hotel.id === hotelId).groupId}
                  preImgURL={preImgURL}
                  setPreImgURL={setPreImgURL}
                  postImgURL={postImgURL}
                  popupImgURL={popupImgURL}
                  setPostImgURL={setPostImgURL}
                  setPopupImgURL={setPopupImgURL}
                  setIsUploading={setIsUploading}
                  cardType={formData.offerType.value}
                />
              </div>
            </div>
          )}
        </div>

        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 3 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={onNextClick}
                size='large'
                className='me-3'
                disabled={isTabInValid}
              >
                Next
              </Button>
            ) : (
              <Button
                disabled={offerLoader || loading || isUploading}
                onClick={handleSubmit}
                variant='contained'
                color='primary'
                className='me-3'
                size='large'
              >
                {!isEmpty(offerItem) ? 'Update' : 'Add'}
              </Button>
            )}
            <Button
              disabled={offerLoader}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {(offerLoader || loading) && (
            <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>
          )}
        </div>
      </div>
    </form>
  );
};

export default OfferCardsCreate;
